import React, { useEffect, useState } from "react";
import "components/form/toggle/toggle.scss";
import classNames from "classnames";
import { useWindowSize } from "hooks/useWindowSize/useWindowSize";
import { TABLET_WIDTH } from "helpers/ScreenSizes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/pro-regular-svg-icons";

type ToggleSize = "small" | "medium";

interface IProps {
  id?: string;
  label?: string;
  supportStyle?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
  labelSupport?: string;
  labelTop?: string;
  labelRight?: string;
  rounded?: boolean;
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
  value?: string | number;
  disabled?: boolean;
  size?: ToggleSize;
  tooltip?: string;
}

export default function Toggle(props: IProps) {
  const windowSize = useWindowSize();
  const [toggleSize, setToggleSize] = useState<ToggleSize>(undefined);

  useEffect(() => {
    if (windowSize?.width > TABLET_WIDTH) {
      setToggleSize(props.size);
    } else {
      setToggleSize("small");
    }
  }, [windowSize, props.size]);

  return (
    <div
      className={classNames("", {
        flex: props.labelRight && props.labelSupport,
      })}
    >
      {props.labelTop && (
        <div className="flex flex-wrap justify-between mb-1 items-end">
          <div className="text-base font-medium text-black block">
            <label
              className={classNames("ui-toggle-label", {
                "ui-toggle-label-small": toggleSize === "small",
                "ui-toggle-label-medium": toggleSize === "medium",
              })}
              style={props.labelStyle}
            >
              {props.labelTop}{" "}
              {props?.tooltip ? (
                <OverlayTrigger
                  placement="auto"
                  overlay={<Tooltip id={"toggle_tool_tip_text"}>{props?.tooltip}</Tooltip>}
                >
                  <FontAwesomeIcon
                    style={{ marginLeft: "0.5rem" }}
                    icon={faQuestionCircle}
                    size="xs"
                    className="ui-toggle-tooltip"
                  />
                </OverlayTrigger>
              ) : null}
            </label>
            {props.labelSupport && (
              <p
                className={classNames("ui-toggle-label-support", {
                  "ui-toggle-label-support-small": toggleSize === "small",
                  "ui-toggle-label-support-medium": toggleSize === "medium",
                })}
                style={props.supportStyle}
              >
                {props.labelSupport}
              </p>
            )}
          </div>
        </div>
      )}

      {props.label ? (
        <div className="inline-block" style={{ marginRight: "0.5rem" }}>
          <div className="text-base font-medium text-black block">
            <label
              className={classNames("ui-toggle-label", {
                "ui-toggle-label-small": toggleSize === "small",
                "ui-toggle-label-medium": toggleSize === "medium",
              })}
              style={props.labelStyle}
            >
              {props.label}{" "}
              {props?.tooltip ? (
                <OverlayTrigger
                  placement="auto"
                  overlay={<Tooltip id={"toggle_tool_tip_text"}>{props?.tooltip}</Tooltip>}
                >
                  <FontAwesomeIcon icon={faQuestionCircle} size="xs" className="ui-toggle-tooltip" />
                </OverlayTrigger>
              ) : null}
            </label>
            {props.labelSupport && (
              <p
                className={classNames("ui-toggle-label-support", {
                  "ui-toggle-label-support-small": toggleSize === "small",
                  "ui-toggle-label-support-medium": toggleSize === "medium",
                })}
                style={props.supportStyle}
              >
                {props.labelSupport}
              </p>
            )}
          </div>
        </div>
      ) : null}

      <label
        className={`ui-toggle
        ${toggleSize === "small" ? " ui-toggle-small " : " ui-toggle-medium "}
        ${props.labelRight ? " inline-block mb-2 shrink-0" : ""}
      `}
      >
        <input
          id={props.id}
          type="checkbox"
          checked={props.checked}
          onChange={props.onChange}
          value={props.value}
          name={props.name}
          disabled={props.disabled}
          className="ui-toggle-input"
        />

        <div
          className={`ui-toggle-slider ${
            toggleSize === "small" ? "ui-toggle-slider-small" : "ui-toggle-slider-medium"
          }`}
        ></div>
      </label>

      {props.labelRight && (
        <div className="inline-block align-top" style={{ marginLeft: "1rem" }}>
          <div className="text-base font-medium text-black block">
            <label
              className={classNames("ui-toggle-label", {
                "ui-toggle-label-small": toggleSize === "small",
                "ui-toggle-label-medium": toggleSize === "medium",
              })}
              style={props.labelStyle}
            >
              {props.labelRight}{" "}
              {props?.tooltip ? (
                <OverlayTrigger
                  placement="auto"
                  overlay={<Tooltip id={"toggle_tool_tip_text"}>{props?.tooltip}</Tooltip>}
                >
                  <FontAwesomeIcon icon={faQuestionCircle} size="xs" className="ui-toggle-tooltip" />
                </OverlayTrigger>
              ) : null}
            </label>
            {props.labelSupport && (
              <p
                className={classNames("ui-toggle-label-support", {
                  "ui-toggle-label-support-small": toggleSize === "small",
                  "ui-toggle-label-support-medium": toggleSize === "medium",
                })}
                style={props.supportStyle}
              >
                {props.labelSupport}
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
